import { StyleSheet } from 'react-native'

export const tabBarStyles = StyleSheet.create({
	select: {
		//alignItems: 'center',
		//paddingHorizontal: ThemedValues.marginHorizontal
	}
})
